<template>
  <div >

    <el-table class="table" size="mini" :data="tableData" :height="hh" border>
      <el-table-column prop="drugName" label="药名" width="100"></el-table-column>
      <el-table-column :formatter="timefilter" prop="beginTime" label="开始日期" min-width="120"></el-table-column>
      <el-table-column :formatter="timefilter" prop="endTime" label="结束日期" min-width="120"></el-table-column>

      <el-table-column prop="takeMethod" label="使用方法" width="100"></el-table-column>
      <el-table-column prop="dosage" label="用药剂量" width="100"></el-table-column>
      <el-table-column prop="treatment" label="使用疗程" width="100"></el-table-column>
      <el-table-column prop="remarks" label="对应疾病或临床表现" width="200"></el-table-column>

      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
      <div style="float: left;">
        <el-pagination
          background small
          layout="prev, pager, next"
          :total="totalItems"
          :page-size="20"
          :current-page.sync="currentPage"  @current-change="current_change"
        ></el-pagination>
      </div>
      <div style="float: right">
        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>
      </div>
      <div style="clear: both;"></div>
    </div>

    <MedicalRecordsAdd ref="myMedicalRecordsAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
                       v-on:getList="getList"></MedicalRecordsAdd>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import MedicalRecordsAdd from "./MedicalRecordsAdd";

export default {
  name: "Role",
  data() {
    return {
      showModalAdd: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,


      userCode: "",
      elderlyCode: "",

      drugName: "",
      beginTime: "",
      takeMetdhod: "",
      dosage: "",
      treatment: "",
      remarks: "",

      hh:this.$store.state.tableHeight-170,

    };
  },
  created() {

  },
  components: {
    MedicalRecordsAdd
  },
  watch: {

    '$store.state.tableHeight' : function(val){
      this.hh = val - 170;
    },
    '$store.state.tableWidth' : function(val){
      console.log(val);
    },

  },
  methods: {

    init(userCode,elderlyCode) {
      this.elderlyCode=elderlyCode;
      this.userCode=userCode;
      this.getList();
    },


    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myMedicalRecordsAdd.init(this.elderlyCode,this.userCode);
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(flag) {
      if(flag)this.currentPage=1
      this.$axios({
        method: "post",
        url: this.$shopUrl + "ETakeDrugs/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          elderlyCode: this.elderlyCode,
          userCode: this.userCode,
        },
      }).then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            this.tableData = response.data.data.list;
            this.totalItems = response.data.data.total;
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });

    },

    //日期格式
    timefilter(row, column, cellValue){
        return timefilters(cellValue).substring(0,11)
    },

    handleDelete(index,row){

      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "ETakeDrugs/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            etakeDrugsCode:row.etakeDrugsCode,

          }
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {

            this.getList();

          } else if (response.data.error == 1) {
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(e => e)

    },




  },
};
</script>

<style scoped>

</style>
